<template>
  <div style="text-align: center;margin-bottom: 600px">
    智慧工业
  </div>
</template>

<script>
export default {
  name: "industry",
  components: {
  },
  data() {
    return {

    };
  },
  created() {},

  mounted() {

  }
};
</script>

<style lang="scss" scoped>

</style>